import React from 'react';
import { SERVICES } from '../constants';
import { ArrowUpRight } from 'lucide-react';
import { motion } from 'framer-motion';

const Services: React.FC = () => {
  return (
    <div className="pt-40 pb-20 bg-black min-h-screen px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-24 border-b border-white/10 pb-12"
        >
           <h1 className="font-serif text-5xl md:text-8xl text-white mb-6">Services Limousine</h1>
           <p className="text-lg md:text-xl text-slate-400 font-light max-w-2xl">
           Profitez d'un service de chauffeur privé d'exception pour tous vos déplacements en Suisse. 
  De l'accueil VIP à l'aéroport de Genève jusqu'à la gestion de vos trajets diplomatiques et événements, 
  LimoHass garantit une ponctualité totale et un confort haut de gamme pour une expérience de voyage 
  en toute sérénité.
           </p>
        </motion.div>

        <motion.div 
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 1,
              transition: { staggerChildren: 0.15 }
            }
          }}
          className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10"
        >
          {SERVICES.map((service) => (
            <motion.div 
              key={service.id} 
              variants={{
                hidden: { opacity: 0, y: 30 },
                visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
              }}
              className="bg-black p-8 md:p-16 group hover:bg-[#080808] transition-colors relative"
            >
               <div className="absolute top-8 right-8 text-white opacity-0 group-hover:opacity-100 transition-opacity">
                  <ArrowUpRight size={24} />
               </div>
               
               <service.icon size={48} className="text-gold-500 mb-8" strokeWidth={1} />
               
               <h3 className="font-serif text-2xl md:text-3xl text-white mb-6">{service.title}</h3>
               <p className="text-slate-400 font-light leading-relaxed text-base md:text-lg">
                  {service.description}
               </p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mt-32 p-8 md:p-12 border border-white/10 bg-[#050505]"
        >
           <div className="flex flex-col md:flex-row items-center gap-12">
              <div className="flex-1">
                 <h2 className="font-serif text-3xl md:text-4xl text-white mb-4">Demandes Sur-Mesure ?</h2>
                 <p className="text-slate-400 font-light">
                    Besoin d'une sécurité rapprochée, d'un guide touristique pour visiter Lausanne ou d'une conciergerie privée ? 
                    Nous répondons à toutes les exigences de notre clientèle internationale.
                 </p>
              </div>
              <motion.a 
                 whileHover={{ scale: 1.05 }}
                 whileTap={{ scale: 0.95 }}
                 href="mailto:contact@limohass.ch" 
                 className="px-8 py-4 bg-white text-black font-bold uppercase tracking-widest hover:bg-gold-500 transition-colors w-full md:w-auto text-center"
              >
                 Contacter 
              </motion.a>
           </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Services;